var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"kt_aside_close_btn"}},[(_vm.archiveMenu)?_c('MenuArchive',{on:{"homePage":_vm.homePage}}):(_vm.atlasMenu)?_c('MenuAtlas',{on:{"homePage":_vm.homePage}}):_c('MenuGU',{on:{"navigate":_vm.navigateTo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }